import { FIELDS_ICON_MAPPER } from "../../../../constants/fields-icon.constant";

function ReadonlyCustomFields({ item, customFieldCanvasRef }) {
    return (
        <>
            <div className="tile__content">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex justify-content-start align-items-center">
                        <i style={{
                            backgroundColor: 'lightgrey',
                            color: 'black',
                            borderRadius: '2px',
                            fontSize: '0.8rem',
                            opacity: 1
                        }} className={`fa-solid me-2 p-2 ${FIELDS_ICON_MAPPER[item?.field_type]}`}></i>
                        <p>{item.field_label}</p>
                    </div>
                    <button onClick={customFieldCanvasRef?.current?.handleShow} type="button" className="form-control btn-default mb-0 w-10">
                        Edit
                    </button>
                </div>
            </div>
        </>
    );
}

export default ReadonlyCustomFields;